<template>
    <DsCard
        class="service-card"
        :class="{selected: isSelected, 'no-label': !service.label}"
        elevation="z0"
        @click="onClick"
    >
        <DsCardHeader
            v-if="service.label"
            class="service-card-label"
        >
            <span data-qa="service-card-label">{{ service.label }}</span>
        </DsCardHeader>
        <DsCardBody class="service-card-heading">
            <div class="service-name">
                <span data-qa="service-name">{{ service.name }}</span>
                <DsStatus
                    v-if="service.status"
                    :type="service.statusType"
                    emphasis="high"
                    class="service-card-status"
                >
                    {{ service.status }}
                </DsStatus>
            </div>
            <DsCheckbox
                v-if="selectable"
                v-model="isSelected"
                class="service-card-checkbox"
            />
            <DsOutlineButton
                v-if="service.button"
                as="a"
                :href="service.button.url"
                target="_blank"
                class="service-card-button"
                trailing-icon="external-link"
            >
                <template #default>
                    {{ service.button.text }}
                </template>
            </DsOutlineButton>
        </DsCardBody>
        <DsCardBody class="service-card-price">
            <div>
                <span>{{ service.price }}</span>/{{ $t('serviceCard.monthText') }}
            </div>
        </DsCardBody>
        <DsCardBody
            class="service-card-list"
        >
            <div class="service-description">
                {{ service.description }}
            </div>
            <DsListItem
                v-for="(benefit, index) in service.benefits"
                :key="index"
                :title="benefit.title"
                :description="benefit.description"
                class="service-benefit-line"
                border-style="none"
            >
                <template #leading>
                    <DsIcon name="check-circle" />
                </template>
            </DsListItem>
        </DsCardBody>
    </DsCard>
</template>

<script>
export default {
    name: 'ServiceCard',
    props: {
        service: {
            type: Object,
            default: () => ({}),
        },
        selectedLevel: String,
        selectable: Boolean,
    },
    emits: ['select-level'],
    computed: {
        isSelected() {
            return this.selectedLevel === this.service.level;
        },
    },
    methods: {
        onClick() {
            if (this.selectable) {
                this.$emit('select-level', this.service.level);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.service-card {
    display: inline-flex;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 0;
    min-width: px-to-rem(320px);
}

.service-card.selected {
    border-color: $color-green-600;
    background: $color-green-050;
}

.service-card.no-label {
    margin-top: $spacing-300;
}

.service-card-label {
    display: flex;
    padding: $spacing-050 $spacing-100;
    justify-content: center;
    align-items: center;
    gap: $spacing-100;
    align-self: stretch;
    background-color: $color-green-600;

    span {
        font-weight: 500;
        line-height: $line-height-sm;
        color: $color-white;
    }
}

.service-card-heading {
    display: flex;
    padding: $spacing-200 $spacing-200 0 $spacing-200;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
}

.service-card-price {
    display: flex;
    padding: 0 0 $spacing-050 $spacing-200;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
}

.service-card-list {
    display: flex;
    padding: $spacing-100 0;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-top: px-to-rem(1px) solid $color-ink-200;

    .service-description {
        display: flex;
        padding: $spacing-200 $spacing-200 $spacing-100 $spacing-200;
        align-items: flex-start;
        gap: $spacing-100;
        align-self: stretch;

        font-size: $font-size-xs;
        font-weight: 500;
        line-height: $line-height-sm;
    }

    .service-benefit-line {
        display: flex;
        padding: $spacing-100 $spacing-200;
        align-items: center;
        align-self: stretch;
        gap: $spacing-200;
    }
}

.service-card-checkbox {
    --checkbox-padding: 0;
}

.service-name {
    font-size: $font-size-lg;
    font-style: normal;
    font-weight: $font-weight-regular;
    line-height: $line-height-xxl;
}

.service-card-status {
    padding-left: $spacing-150;
}

.service-card-price span {
    font-size: $font-size-xl;
    font-style: normal;
    font-weight: $font-weight-bold;
    line-height: $line-height-xxl;
}

:deep(.service-card-list .one-line) {
    text-wrap: wrap;
}

:deep(.service-card .leading-slot) {
    padding: 0;
}
</style>
